module.exports = __webpack_public_path__ + "img/pick8_Prizes_Stadium.cdcb5f26.jpg";